module.exports = __webpack_public_path__ + "img/icon_dentalia.935de37d.svg";